<div class="container-fluid">
  <div class="row justify-content-start">
    <div class="col-md-8 col-xs-12">
      <div class="mt-3" name="timeSpan" aria-label="Time Span">
        <mat-button-toggle class="lw-toggle-btn" [ngClass]="this.timespan === 'weekly' ? 'active' : ''" value="weekly" (click)="changeTimeSpan('weekly')">Weekly</mat-button-toggle>
        <mat-button-toggle class="lw-toggle-btn" [ngClass]="this.timespan === 'monthly' ? 'active' : ''" value="monthly" (click)="changeTimeSpan('monthly')">Monthly</mat-button-toggle>
        <mat-button-toggle class="lw-toggle-btn" [ngClass]="this.timespan === 'custom' ? 'active' : ''" value="custom" (click)="changeTimeSpan('custom')">Custom</mat-button-toggle>
      </div>
      <lds-energy-status></lds-energy-status>
      <!-- <div class="mt-3" name="graphType" aria-label="Graph Type">
      <mat-button-toggle class="lw-toggle-btn" [ngClass]="this.graphType === 'bar' ? 'active' : ''" value="bar"
      (click)="changeGraphType('bar')">Bar Graph</mat-button-toggle>
      <mat-button-toggle class="lw-toggle-btn" [ngClass]="this.graphType === 'line' ? 'active' : ''" value="line"
      (click)="changeGraphType('line')">Line Graph</mat-button-toggle>
    </div> -->
    <div class="left-graph-container">
      <lds-y3-energy-overview-chart></lds-y3-energy-overview-chart>
      <!-- <app-graph [data]= "switchData" [features]= "switchFeatures" graphName = "device-detail" *ngIf="show"></app-graph> -->
      <!-- <app-graph [data]= "recentActivity" graphName = "recentActivity" *ngIf="recentActivity"></app-graph> -->
    </div>

  </div>

  <div class="pl-md-0 col-md-4 pt-md-4 pt-3 col-xs-12 mb-2">
    <div class="lds-container scroll container-fluid mb-2" style="height:212px">
      <div class="row justify-content-center px-4">
        <div class="col-6 px-1">
          <button class='lds-btn active' type="button" name="button" (click)='buttonClicked("all_rooms")'>All Rooms</button>
        </div>
        @for (room of rooms; track room) {
          <div class="col-6 px-1">
            <button class='lds-btn active' type="button" name="button" (click)='buttonClicked(room)' title='name (devices with energy)'>
              {{room.name}} ({{room.featureSetsWithData}})
              @if (multipleStructures && room.homeName) {
                <div title='Location name' style='font-size: small;'>{{room.homeName}}</div>
              }
            </button>
          </div>
        }
        <!-- <button fxFlex="48%" class='lw-btn active' type="button" name="button" *ngFor="let room of user.rooms" (click)='buttonClicked(room)'>{{room.name}}</button> -->
      </div>
    </div>
    <lds-featureset-list></lds-featureset-list>
  </div>
</div>
</div>

<div class="lds-container SD-graph-main h250 mt-2">
  <div #graph class="SD-graph">
  </div>
</div>
